/**
 * Чтение профессий таланта.
 *
 * api-gateway отдаёт профессии обогащёнными: profession, department, position и
 * similarTerm — объекты из Libraries Service. Денормализованные *_name в talent_professions часто
 * пустые (например, при записи через MCP приходят только *_id) или устаревшие,
 * поэтому читаем сначала агрегированные данные, а снимок из БД оставляем запасным
 * вариантом — на случай, если libraries-service недоступен.
 */

export const getProfessionName = (prof) =>
  prof?.profession?.name || prof?.profession_name || ''

export const getDepartmentName = (prof) =>
  prof?.department?.name || prof?.department_name || prof?.profession?.department_name || ''

export const getDepartmentCode = (prof) =>
  prof?.department?.code || prof?.department_code || null

export const getSimilarTermName = (prof) =>
  prof?.similarTerm?.value || prof?.similarTerm?.name || prof?.similar_term_name || ''

export const getPositionName = (prof) =>
  prof?.position?.name || prof?.position_name || ''

/**
 * Название для показа: если профессия помечена как похожая, показываем терм,
 * иначе — основную профессию.
 */
export const getDisplayProfessionName = (prof) =>
  getSimilarTermName(prof) || getProfessionName(prof)

/**
 * Основная профессия таланта: помеченная is_primary, иначе первая в списке.
 */
export const getPrimaryProfession = (talent) =>
  talent?.professions?.find(p => p.is_primary) || talent?.professions?.[0] || null
